import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { useAlerts } from "context/AlertContext";
import { IFeatureFlag } from "models/featureFlags.models";
import { services } from "services";
import { AlertSeverity } from "utils/constants/alerts.constants";
import { QueryAPIKey } from "utils/constants/api.constants";
import handleRetryFailure from "utils/helpers/handleRetryFailure";

export const query = gql`
  query FeatureFlags {
    featureFlags {
      name
      value
      description
    }
  }
`;

function useGetFeatureFlags() {
  const { t } = useTranslation("common", { keyPrefix: "notifications" });

  const { showAlert } = useAlerts();

  const { data, isLoading, isSuccess, isError } = useQuery<{
    featureFlags?: IFeatureFlag[];
  }>({
    queryKey: [QueryAPIKey.GetFeatureFlags],
    queryFn: () =>
      services.graphQL.request<{ featureFlags?: IFeatureFlag[] }>(query),
    retry: handleRetryFailure(() =>
      showAlert({
        severity: AlertSeverity.Error,
        message: t("loadFeatureFlagsFailure"),
      }),
    ),
    enabled: true,
  });

  return {
    featureFlags: data?.featureFlags,
    isLoading,
    isSuccess,
    isError,
  };
}

export default useGetFeatureFlags;
